import { addSideEffects, initAction } from '@poa/state';
import { clone } from '../shared/clone';
import {
  updateAccount,
  fetchAccount,
  fetchAccountReports,
  fetchAccounts,
  fetchShiftMap,
  refreshAccounts,
  saveColumnPreset,
  changeColumnPreset,
  deletePreset,
  createShiftPeriod,
  updateShiftPeriod,
  deleteShiftPeriod
} from './accounts.actions';


const accountsAvailablePresets = 'accountsAvailablePresets-v2';
const accountsLastSelectedPreset = 'accountsLastSelectedPreset-v2';


async function fetchAccountsFilterRequest(env, {
  filter_by = null,
  page = 1,
  sort_by = null,
  search = null,
  page_size = 15,
  status = null
}) {
  return env.api.accounts.fetchAccountsFilter(filter_by, page, sort_by, search, page_size, status);
}


addSideEffects(fetchAccount, async (payload, { actions, env }) => {
  try {
    const account_model = await env.api.accounts.fetchAccount(payload.id);
    actions.accountsActions.fetchAccountSuccess(account_model);
  } catch (e) {
    console.error(e);
    env.alert('Ошибка', `${e.response.data.error_message}`);
  }
});

addSideEffects(fetchAccountReports, async (payload, { actions, env }) => {
  try {
    const reports = await env.api.accounts.fetchAccountReports(payload.id);
    actions.accountsActions.fetchAccountReportsSuccess(reports);
  } catch (e) {
    console.error(e);
    env.alert('Ошибка', `${e.response.data.error_message}`);
  }
});


addSideEffects(updateAccount, async (payload, { actions, env }) => {
  try {

    await env.api.accounts.updateAccount(payload);
    const account_model = await env.api.accounts.fetchAccount(payload.id);
    actions.accountsActions.fetchAccountSuccess(account_model);
  } catch (e) {
    console.error(e);
    env.alert('Ошибка', `${e.response.data.error_message}`);
  }
});


addSideEffects(fetchAccounts, async (payload, { actions, env }) => {
  try {
    const accounts = await env.api.accounts.fetchAccounts([], 1, payload.sortingMap);
    actions.accountsActions.fetchAccountsSuccess(accounts);
  } catch (e) {
    console.error(e);
    actions.accountsActions.fetchAccountsFailed();
    throw e;
  }
});

addSideEffects(
  refreshAccounts,
  async ({
           filter_by,
           page,
           sort_by,
           search,
           page_size,
           status
         }, { actions, env }) => {
    try {
      let params = {};
      let index = 0;
      sort_by.forEach(( mode, header) => {
        if (mode !== 'none') {
          params[header] = {direction: mode, order: index};
          index += 1
        }
      });

      const accounts = await fetchAccountsFilterRequest(env, {
        filter_by: filter_by,
        page: page,
        sort_by: params,
        search: search,
        page_size: page_size,
        status: status
      });

      actions.accountsActions.fetchAccountsSuccess(accounts);
    } catch (e) {
      console.error(e);
      actions.accountsActions.fetchAccountsFailed();
      throw e;
    }
  });

addSideEffects(saveColumnPreset, async (_, { env, actions, store }) => {
  const { availablePresets, currentPresetId } = store.accounts.filters.columnSettings;

  await env.storage.setItem(accountsAvailablePresets, clone(availablePresets));
  await env.storage.setItem(accountsLastSelectedPreset, currentPresetId);
});

addSideEffects(deletePreset, async (_, { env, actions, store }) => {
  const { availablePresets, currentPresetId } = store.accounts.filters.columnSettings;

  await env.storage.setItem(accountsAvailablePresets, clone(availablePresets));
  await env.storage.setItem(accountsLastSelectedPreset, currentPresetId);
});

addSideEffects(changeColumnPreset, async ({ preset }, { env, actions, store }) => {
  const { currentPresetId } = store.accounts.filters.columnSettings;

  await env.storage.setItem(accountsLastSelectedPreset, currentPresetId);
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const availablePresets = await env.storage.getItem(accountsAvailablePresets);
  const currentPresetId = await env.storage.getItem(accountsLastSelectedPreset);

  if (availablePresets && currentPresetId) {
    actions.accountsActions.resetColumnSettings({ presetId: currentPresetId, availablePresets });
    return;
  }

  if (availablePresets) {
    actions.accountsActions.resetColumnSettings({
      presetId: availablePresets[0].id, // default one
      availablePresets
    });
    return;
  }

  actions.accountsActions.resetColumnSettings({
    presetId: store.accounts.filters.columnSettings.availablePresets[0].id, // default one
    availablePresets: store.accounts.filters.columnSettings.availablePresets
  });
});


addSideEffects(
  createShiftPeriod,
  async (payload , { actions, env }) => {

    try {

      const shifts = await env.api.accounts.createShiftPeriod(payload.from, payload.to, payload.accountId);

      actions.accountsActions.createShiftPeriodSuccess(shifts);
    } catch (e) {
      console.error(e);
      env.alert('Ошибка', `${e.response.data.error_message}`);
    }
  });


addSideEffects(
  updateShiftPeriod,
  async (payload , { actions, env }) => {

    try {

      const shifts = await env.api.accounts.updateShiftPeriod(payload.operatorId, payload.periodId);
      actions.accountsActions.createShiftPeriodSuccess(shifts);

      const shiftTransfers = await env.api.accounts.fetchShiftTransfers(payload.accountId);
      actions.accountsActions.fetchShiftTransfersSuccess(shiftTransfers);
    } catch (e) {
      console.error(e);
      env.alert('Ошибка', `${e.response.data.error_message}`);
    }
  });


  addSideEffects(
    deleteShiftPeriod,
    async (payload , { actions, env }) => {
  
      try {
  
        const shifts = await env.api.accounts.deleteShiftPeriod(payload.periodId);
        actions.accountsActions.createShiftPeriodSuccess(shifts);

        const shiftTransfers = await env.api.accounts.fetchShiftTransfers(payload.accountId);
        actions.accountsActions.fetchShiftTransfersSuccess(shiftTransfers);
      } catch (e) {
        console.error(e);
        env.alert('Ошибка', `${e.response.data.error_message}`);
      }
    });


addSideEffects(fetchShiftMap, async (payload, { actions, env }) => {
  try {
    const data = await env.api.accounts.fetchShiftMap(payload.id);
    actions.accountsActions.fetchShiftMapSuccess(data);
    return data;
  } catch (e) {
    console.error(e);
    env.alert('Ошибка', `${e.response.data.error_message}`);
  }
});